module.exports = __webpack_public_path__ + "img/IMG_3945_L_WoodMatted.35055b39.jpg";